module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/home/lamp-2-dbff3f228aae79c321ae4872fe80f578.svg";